// extracted by mini-css-extract-plugin
export var card = "FeatureBlock-module--card--a7226";
export var cardTitle = "FeatureBlock-module--cardTitle--4a3f3";
export var description = "FeatureBlock-module--description--7c814";
export var innerSeparator = "FeatureBlock-module--innerSeparator--2df44";
export var separator = "FeatureBlock-module--separator--07863";
export var title = "FeatureBlock-module--title--a20f1";